import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card card-gray mt-3 p-3" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-9 pe-2" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_7 = { class: "col-3 pe-0 form-height" }
const _hoisted_8 = ["aria-label", "title"]
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "small" }
const _hoisted_11 = { class: "mt-3" }
const _hoisted_12 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StairsIcon = _resolveComponent("StairsIcon")!
  const _component_RoomControl = _resolveComponent("RoomControl")!
  const _component_DoorIcon = _resolveComponent("DoorIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(["input-group-text input-part-stair-icon input-group-icon my-2", {'is-invalid': _ctx.isNameInvalid()}])
          }, [
            _createVNode(_component_StairsIcon, { class: "text-primary" })
          ], 2),
          _createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control my-2", {'is-invalid': _ctx.isNameInvalid()}]),
            value: _ctx.state.name,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateName($event.target.value))),
            placeholder: _ctx.$t('form.floorArea.buildingPartName')
          }, null, 42, _hoisted_5)
        ]),
        (_ctx.isNameInvalid())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('form.errors.buildingPartNotFilled')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-outline-secondary",
          "aria-label": _ctx.$t('form.floorArea.buttonCloneBuildingPart'),
          title: _ctx.$t('form.floorArea.buttonCloneBuildingPart'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clone')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "fas fa-clone" }, null, -1)
        ]))], 8, _hoisted_8),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove'))),
          class: "btn btn-outline-secondary ms-2"
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "fas fa-times" }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.hasRooms())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('form.floorArea.rooms')) + _toDisplayString(_ctx.state.name.length !== 0 ? ' – ' + _ctx.state.name : ''), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('form.floorArea.roomHelp')), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.rooms, (_, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mb-4"
        }, [
          _createVNode(_component_RoomControl, {
            ref_for: true,
            ref: index,
            state: _ctx.state.rooms[index],
            roomLists: _ctx.roomLists,
            validate: _ctx.validate && _ctx.state.rooms[index].value === null,
            onRemove: ($event: any) => (_ctx.removeRoom(index)),
            onClone: ($event: any) => (_ctx.cloneRoom(index))
          }, null, 8, ["state", "roomLists", "validate", "onRemove", "onClone"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addRoom()))
            }, [
              _createVNode(_component_DoorIcon, { class: "input-icon" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('form.floorArea.buttonAddRoom')) + " " + _toDisplayString(_ctx.state.name.length !== 0 ? ' – ' + _ctx.state.name : ''), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}